import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { EmptyState } from 'components/EmptyState'

export const EmptyStateProduct = () => {
  const { t } = useTranslation()

  return (
    <EmptyState
      animationUrl={`/assets/animation-empty-products.svg`}
      description={t('e-commerce:empty.description')}
    />
  )
}

EmptyStateProduct.displayName = 'EmptyStateProduct'
